import {AxiosHttpClientAdapter} from '../../../infra/adapters/axios-adapter'
import {HttpClient} from '../../../infra/adapters/type'
import { FetchHttpClientAdapter } from '../../adapters/fetch-adapter'

export type ApiResult = {
  itens: any[]
  service: string
  total: number
  message?: string
}
export class APiUrbit {
  host: string = (process.env.REACT_APP_URBIT_API_URL || '').replace(/\/?$/, '/')
  bearer: string = ''
  clienteConect: any
  constructor(httpClientRequest: HttpClient) {
    this.clienteConect = httpClientRequest
  }
  init() {
    //api
    // this.setHost()
    return []
    // setHor
  }
  setBearer(bearer) {
    this.bearer = bearer
  }
  setHost() {
  }

  getBearer() {
    const tokens = [
      localStorage.getItem('api_token_api_gis')
    ]

    return tokens.find((token) => token && token !== 'undefined' && token !== 'null') || ''
  }

  async request(method: string, url: string, data = '') {
    let body = data ? JSON.stringify(data) : null
    const result = await this.clienteConect.request({
      url: this.host + url,
      method: method,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${this.getBearer()}`,
      },
      body,
    })

    if (result.statusCode === 200) {
      return result.body
    } else {
      return {service: 'error', message: `Erro status: ${result.status}`, itens: [], total: 0}
    }
  }

  async get(url: string, callback?: any) {
    if (typeof callback == 'function') {
      fetch(this.host + url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.getBearer()}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else {
            return null
          }
        })
        .then((data) => {
          if (!data || typeof data === 'undefined') {
            callback({service: 'erro', message: data, itens: [], total: 0})
          } else {
            callback(data)
          }
        })
        .catch((err) => {
          callback({service: 'error', message: err.message, itens: [], total: 0})
        })
    } else {
      try {
        return this.request('GET', url)
      } catch (error) {
        console.error('Error:', error)
        return {service: 'error', message: error, itens: [], total: 0}
      }
    }
  }

  async getServico(
    servico: string,
    lat: number,
    lng: number,
    municipio: string,
    distancia?: number,
    callback?: any,
    intersect?: string
  ): Promise<ApiResult> {
    distancia = !distancia ? 500 : distancia

    // console.log(callback)
    // console.log(intersect)
    if (servico !== '') {
      let urlParam = `municipio/[MUNICIPIO]/[SERVICO]/[LONGITUDE]/[LATITUDE]?distance=[DISTANCIA]`
        .replace('[LONGITUDE]', String(lng))
        .replace('[LATITUDE]', String(lat))
        .replace('[SERVICO]', servico)
        .replace('[MUNICIPIO]', municipio)
        .replace('[DISTANCIA]', distancia + '')

      if (intersect) {
        urlParam = urlParam + '&intersect=' + intersect
      }
      if (typeof callback == 'function') {
        fetch(this.host + urlParam, {
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.getBearer()}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            } else {
              return null
            }
          })
          .then((data) => {
            if (!data || typeof data === 'undefined') {
              callback({service: 'erro', message: data, itens: [], total: 0})
            } else {
              callback(data)
            }
          })
          .catch((err) => {
            callback({service: 'error', message: err.message, itens: [], total: 0})
          })
      } else {
        try {
          const result = await this.request('GET', urlParam)
          if (typeof result.message !== 'undefined') {
            return {service: 'error', message: result.message, itens: [], total: 0}
          } else {
            return result
          }
        } catch (error) {
          console.error('Service:', servico)
          console.error('Error:', error)
          return {service: 'error', message: error, itens: [], total: 0}
        }
      }
    } else {
      return {service: 'error', message: null, itens: [], total: 0}
    }
  }

  async getServicoNacional(
    servico: string,
    lat: number,
    lng: number,
    municipio: string,
    distancia?: number,
    callback?: any,
    intersect?: string,
    limite?: number
  ): Promise<ApiResult> {
    distancia = !distancia ? 500 : distancia
    limite = !limite ? 20 : limite

    // console.log(callback)
    // console.log(intersect)
    if (servico !== '') {
      let urlParam = `service/[SERVICO]/[LONGITUDE]/[LATITUDE]?distance=[DISTANCIA][LIMITE]`
        .replace('[LONGITUDE]', String(lng))
        .replace('[LATITUDE]', String(lat))
        .replace('[SERVICO]', servico)
        .replace('[MUNICIPIO]', municipio)
        .replace('[DISTANCIA]', distancia + '')
        .replace('[LIMITE]', '&limit=' + limite)

      if (intersect) {
        urlParam = urlParam + '&intersect=' + intersect
      }
      if (typeof callback == 'function') {
        fetch(this.host + urlParam, {
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.getBearer()}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            } else {
              return null
            }
          })
          .then((data) => {
            if (!data || typeof data === 'undefined') {
              callback({service: 'erro', message: data, itens: [], total: 0})
            } else {
              callback(data)
            }
          })
          .catch((err) => {
            callback({service: 'error', message: err.message, itens: [], total: 0})
          })
      } else {
        try {
          const result = await this.request('GET', urlParam)
          if (typeof result.message !== 'undefined') {
            return {service: 'error', message: result.message, itens: [], total: 0}
          } else {
            return result
          }
        } catch (error) {
          console.error('Service:', servico)
          console.error('Error:', error)
          return {service: 'error', message: error, itens: [], total: 0}
        }
      }
    } else {
      return {service: 'error', message: null, itens: [], total: 0}
    }
  }
  async post(url: string, dataInput: any, callback?: any) {
    if (typeof callback == 'function') {
      fetch(this.host + url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${this.getBearer()}`,
        },
        body: JSON.stringify(dataInput),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else {
            return null
          }
        })
        .then((data) => {
          if (!data || typeof data === 'undefined') {
            callback({service: 'erro', message: data, itens: [], total: 0})
          } else {
            callback(data)
          }
        })
        .catch((err) => {
          callback({service: 'error', message: err.message, itens: [], total: 0})
        })
    } else {
      return this.request('POST', url, JSON.stringify(dataInput))
      //   let data = null
      //   try {
      //     const response = await fetch(this.host + url, {
      //       method: 'POST',
      //       headers: {
      //         'Content-Type': 'application/json',
      //         Authorization: `Bearer ${this.bearer}`,
      //       },
      //       body: JSON.stringify(dataInput),
      //     })
      //     data = await response.json()
      //   } catch (error) {
      //     data = {service: 'error', message: error, itens: [], total: 0}
      //     console.error('Error:', error)
      //   }

      //   return data
    }
  }
}

export const ApiUrbit = new APiUrbit(new FetchHttpClientAdapter())
